export default __webpack_public_path__ + "static/media/photo--sm--hockey3.54c9501a.jpg";